import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { FadeIn } from './FadeIn';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-brand-navy/10 last:border-0" data-id="element-74">
      <button className="w-full py-6 flex justify-between items-center text-left focus:outline-none group" onClick={onClick} aria-expanded={isOpen} data-id="element-75">
        <span className="text-xl font-bold text-brand-navy group-hover:text-brand-teal transition-colors pr-8" data-id="element-76">
          {question}
        </span>
        <ChevronDown className={`w-6 h-6 text-brand-teal flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-77" />
      </button>
      <AnimatePresence data-id="element-78">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-79">
            <p className="pb-6 text-lg text-brand-gray leading-relaxed" data-id="element-80">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'Does my teen need a laptop or expensive camera?',
    answer: 'No. A standard smartphone from the last 3 years is all they need to take high-quality content and manage accounts.'
  }, {
    question: 'How much time does this take?',
    answer: 'Once the systems are set up, most teens spend about 30 minutes a day on engagement and 2 hours on the weekend "batching" content.'
  }, {
    question: 'Is this safe for my kid?',
    answer: 'Yes. This method focuses on local brick-and-mortar businesses you already know and visit, keeping the interaction grounded in the real community.'
  }, {
    question: 'What if my teen is shy?',
    answer: 'The guide includes a "Parent-Partner" section on how to help bridge the initial introduction to business owners.'
  }];
  return <section className="bg-brand-cream py-24 px-6" data-id="element-81">
      <div className="max-w-3xl mx-auto" data-id="element-82">
        <FadeIn data-id="element-83">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-84">
            Frequently Asked Questions
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-85">
          <div className="bg-white rounded-3xl p-6 md:p-10 shadow-sm border border-brand-navy/5" data-id="element-86">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-87" />)}
          </div>
        </FadeIn>
      </div>
    </section>;
}